import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import Button from "@mui/joy/Button";

// components
import BaseApi from "../../utils/BaseApi";
import VideoPlayer from "./VideoPlayer";



class MessageVideo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            load: false,
        }
    }

    async componentDidMount() {
    }


    async retrieveContent(){
        this.setState({
            load: true
        })
        const url = `message/${this.props.message.id}/download`;
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        this.setState({
            content: response.data.content
        })
    }

    render() {
        if (!this.state.load) {
            return (
                <Stack>
                    <Button
                        onClick={this.retrieveContent.bind(this)}
                    >
                        Загрузить видео
                    </Button>
                </Stack>
            )
        }
        if (this.state.load && !this.state.content) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Stack>
                <VideoPlayer
                    base64String={this.state.content}
                    extension={this.props.message.extension}
                />
            </Stack>
        )
    }
}

export default MessageVideo
